import React from 'react';

import { BaseCardProps } from '../types';

const CardTitle: React.FC<Pick<BaseCardProps, 'title'>> = (props) => {
  const { title } = props;

  return (
    <div className="Card__title">
      <h3>{title}</h3>
    </div>
  );
};

export default CardTitle;
